$(function() {
    'use strict';

    // console.log('start ajax');

    let tmot = 60000;

    if ($mcaAcOp[0]) { // запуск счетчика
        // reTu($('#dukRel'), 2);
        reTu($mcaAcOp, 2);
        getDukResAcOp($mcaAcOp);
        // setInterval(function () {if (!$mcaAcOp.attr('data-dr')) }, 500);
        setInterval(function () {
            if (!$mcaAcOp.attr('data-dr')) getDukResAcOp($mcaAcOp)
        }, tmot);
    }

    let widget;

    if ($('#chart3')[0]) {
        widget = new dc.dukascoin.ChartUI({
            uri: "//freeserv.dukascopy.com/2.0/?path=dukascoins_statistics/monthlyMCA&period=1YEAR",
            subTitleColor: '#b3b3b3',
            backgroundColor: 'transparent',
            scrollerColor: '#d92a28',
            scrollerOpacity: 0,
            subTitleFontSize: 8,
            yMinMaxOffset: 0,
            chartPaddingLeft: 0,
            chartPaddingRight: 0,
            scaleMinimalUnitCount: 5,
            //initialDataUnitCount: 40,
            initialStartTimePoint: dc.dukascoin.ChartUI.Display.ALL,
            showButtons: false,
            showInstrumentSelector: false,

            showProgressStyle: true,
            renderingStrategy: dc.dukascoin.RenderingStrategy.HISTOGRAM,
            seriesOptions : {
                'yPaddingMin'  : 0,
                'yPaddingMax'  : 0.08
            }


        });

        widget.setMargin(5, 10, 80, 45);
        widget.getAxisYComponent().setFontSize(10);
        widget.getAxisXComponent().setFontSize(10);

        widget.setMarkerLineColor('transparent');
        widget.setChartBorderColor(['#3c2e2e', 'transparent']);
        widget.getAxisXComponent().setColor('transparent');
        widget.getAxisXComponent().setVertical(true);
        widget.getAxisXComponent().setLabelFormat(dc.dukascoin.Format.SHORTMONTHYEAR);
        widget.getAxisXComponent().setStep(1);
        widget.getAxisXComponent().setFontColor('#b3b3b3');
        widget.getAxisYComponent().setFontColor('#b3b3b3');
        widget.getAxisYComponent().setColor('#3c2e2e');
        widget.getAxisYComponent().setLabelsRounding(10);
        widget.getAxisYComponent().setLabelFormat(function(v) {
            return v | 0;
        });

        widget.addEventListener('chartdataloaded', function() {
            widget.getChart().setCheckForDuplicates(true);
            widget.getChart().setDisplayLabelXCoordinate(true);
            widget.getChart().setLabelFormatFunction(function(value) {
                return value | 0;
            });
            widget.getChart().setLabelXCoordinateFormatFunction(dc.dukascoin.Format.SHORTMONTHYEAR);

            widget.getChart().setLabelBg('#d92726');
            widget.getChart().setShadowColor('#50100e');
            widget.getChart().setLabelBorderColor('#50100e');
            widget.getChart().setColor('#d92726',0.5);
            widget.getChart().setCheckPointRadius(12);
        });


        widget.render(document.getElementById('chart3'));
    }

});

function reTu(d,s) { // запуск анимации проворота счетчика
    let y = [];
    if (!s) s = 10;

    let c = 1;
    if (d[0].id === 'dukRel') c = 20;

    if (!d) {
        console.log(y);
        d = $mcaAcOp;
        y = d.text().split('\'');
        y = y.join('');
        y = ''+(parseInt(y)-s);
        console.log(s);
        console.log(y);
        y = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        y = y.split(",");

    } else if (d[0].id === 'dukRel') {
        y = d.text().split('\'');
        y = y.join('');
        y = ''+(parseInt(y)-((s+1)*20));
        y = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        y = y.split(",");

    }  else if (d[0].id === 'mcaAcOp') {
        y = d.text().split('\'');
        y = y.join('');
        y = ''+(parseInt(y)-(s+1));
        y = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        y = y.split(",");

    } else y = d.text().split('\'');

    let rdy = y.join('');
    rdy = ''+(parseInt(rdy)+c);
    let   mdy = rdy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    mdy = mdy.split(",");
    let e = mdy;

    let ht = '';
    for (let i = 0; i < e.length ; i++){
        ht += e[i];
        if (i<(e.length-1))ht += '\'';
    }
    d.html('<b>'+ht+'</b>');

}

function fzam(d) { // запуск анимации проворота счетчика
    let y;

    if (!d) {
        d = $mcaAcOp;
        y = d.text().split('\'');
        y = y.join('');
        y = ''+(parseInt(y)-2);
        y = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        y = y.split(",");

    } else y = d.text().split('\'');

    let c = 1;
    if (d[0].id === 'dukRel') c = 20;
    let rdy = y.join('');
    rdy = ''+(parseInt(rdy)+c);
    let   mdy = rdy.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    mdy = mdy.split(",");
    let e = mdy;

    let ht = '';
    for (let i = 0; i < e.length ; i++){
        if (c===1){
            for (let t = 0; t < e[i].length ; t++){
                if (y[i][t] === e[i][t]) ht += '<div class="df"><b>'+y[i][t]+'</b><b>'+e[i][t]+'</b></div>';
                else ht += '<div class="df vb"><b>'+y[i][t]+'</b><b>'+(parseInt(e[i][t]))+'</b></div>';
            }
        } else {
            for (let o = 0; o < y[i].length ; o++){
                if (y[i][o] === e[i][o]) ht += '<div class="df"><b>'+y[i][o]+'</b><b>'+e[i][o]+'</b></div>';
                else ht += '<div class="df vb"><b>'+y[i][o]+'</b><b>'+e[i][o]+'</b></div>';
            }
        }
        if (i<(e.length-1)) ht += '<div>\'</div>';
    }
    d.html(ht);

    setTimeout(function (){
        d.addClass('an');
        ht = '';
        for (let i = 0; i < e.length ; i++){
            ht += e[i];
            if (i<(e.length-1))ht += '\'';
        }
        setTimeout(function (){
            d.removeClass('an');
            d.html('<b>'+ht+'</b>');
            d.attr('data-dr',ht);
        },2700);
    },100);

}

function getDukResAcOp(op) { // получение новых данных и запуск счетчика
    op.attr('data-dr',op.text());

    $.get('//www.dukascoin.com/ajax.php', {key:'coinVars01'}, function (acres) {
        let acmca = masToData(acres.MCA_COUNT);
        let timerId = setInterval(function (){
            if (masToData(op.attr('data-dr')) >= acmca) {
                op.removeAttr('data-dr');
                clearInterval(timerId);
            }else if  (masToData(op.attr('data-dr')) === masToData((op.text()))) {
                fzam($mcaAcOp);
            } else console.log('prop');
        },3000);
    });
}


function masToData(m) { // строка типа 12'345 -> цифры 12345
    let d = 0;
    if (typeof m == "string") {
        d = parseInt(m.split('\'').join(''));
        return d;
    } else {
        console.log(m);
        return d;
    }
}